import { Component, EventEmitter, OnInit, Input, Output, ViewChild, ElementRef } from '@angular/core';
import { Router }            from '@angular/router';
import {Message, OverlayPanel, SelectItem, ConfirmDialog, ConfirmationService, SplitButton, MenuItem} from 'primeng/primeng';
import {UIChart} from 'primeng/primeng';

import * as ent from '../../entities/index'
import * as filters from '../../filters/index'
import * as enums from '../../enums/index'
import * as serv from '../../services/index'

//constants
import { Constants }         from '../../constants/Constants';

//components
import {MessageHandlerComponent} from '../Controls/MessageHandler.component';
import {BlockComponent} from '../Controls/Block.component';


@Component({
  selector: 'my-validation-grid',
  templateUrl: './ValidationGrid.component.html'
})
export class ValidationGridComponent implements OnInit {

    userInfo: ent.UserInfo;
    @ViewChild(MessageHandlerComponent) messageHandlerComponent: MessageHandlerComponent;
    @ViewChild(BlockComponent) blockComponent: BlockComponent;
    records: ent.Validation[];
    cols: any[];

    constructor(private configService: serv.ConfigService, private authenticationService: serv.AuthenticationService, 
        private router: Router, private domaindataService: serv.DomainDataService) 
    { 
      

    }

    ngOnInit(): void {

        if (!this.authenticationService.checkLoginStatus())
        {
            this.router.navigate(['login']);
        }
        this.userInfo = this.authenticationService.getUserInfo();
        this.loadColumns();
        this.onSearchClick(null);
    }

    loadColumns(){
        //Note: this is only needed for the p-table exportCSV function to work. Without loading the columns, that will throw an error.
        this.cols = [
            { field: 'ID', header: 'ID' },
            { field: 'RequestTypeID', header: 'Request Type ID' },
            { field: 'RequestType.Name', header: 'Request Type Name' },
            { field: 'SectionID', header: 'Section ID' },
            { field: 'Section.Name', header: 'Section Name' },
            { field: 'FieldID', header: 'Field ID' },
            { field: 'Field.Name', header: 'Field Name' },
            { field: 'Inactive', header: 'Inactive' },
        ];
    }

    public onSearchClick(event: any){
        this.blockComponent.blocked = true;
        var filter: filters.ValidationFilter = {IncludeInactive: true};
        this.domaindataService.getValidations(filter).subscribe(x=> {
            this.records = x;
            this.blockComponent.blocked = false;
        }, err => {
            this.messageHandlerComponent.handleResponse({Success: false, ValidationMessages: [{Category: "error", MessageText: err}]})
            this.blockComponent.blocked = false;
        });
    }
}